module.exports = __webpack_public_path__ + "static/img/blog-05.ea9cee2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog/blog-05.jpg
// module id = 8LrS
// module chunks = 7